import React, { useState, useCallback, useEffect } from "react";
import {
  FormLayout,
  Card,
  Loading,
  TextField,
  Text,
  Page,
  Toast,
  PageActions,
} from "@shopify/polaris";
import axios from "../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import { accessSettings } from "../Helpers";

const ContactInformation = (props) => {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(true);
  const [item, setItem] = useState({
    phoneNumber: "",
    email: "",
    address: "",
  });
  const handleChangePhoneNumber = (newValue) => {
    setItem({ ...item, phoneNumber: newValue });
  };
  const handleChangeEmail = (newValue) => {
    setItem({ ...item, email: newValue });
  };
  const handleChangeAddress = (newValue) => {
    setItem({ ...item, address: newValue });
  };
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  useEffect(() => {
    axios
      .get(`settings/contact-details`)
      .then((result) => {
        setIsSaving(false);
        setItem({
          phoneNumber: result?.data?.data?.contact_phone
            ? result?.data?.data?.contact_phone
            : "",
          email: result?.data?.data?.contact_email
            ? result?.data?.data?.contact_email
            : "",
          address: result?.data?.data?.address?.en
            ? result?.data?.data?.address?.en
            : "",
        });
      })
      .catch((err) => console.log(err));
  }, []);
  const handleSave = () => {
    setIsSaving(true);
    const form_data = new FormData();
    item.email && form_data.append("contact_email", item.email);
    item.phoneNumber && form_data.append("contact_phone", item.phoneNumber);
    item.address && form_data.append("address", item.address);

    form_data.append("_method", "PATCH");
    axios
      .post(`settings/contact-details`, form_data)
      .then((res) => {
        setIsSaving(false);
        toggleActive();
      })
      .catch((err) => console.log(""));
  };

  return (
    accessSettings() && (
      <Page title="Notifications">
        <Card sectioned>
          {isSaving ? <Loading /> : null}
          <FormLayout>
            {/* <FormLayout.Group>
            <FormLayout>
              <Text variant="bodyMd" as="p" fontWeight="semibold">
                Phone
              </Text>
              <TextField
                value={item.phoneNumber}
                onChange={handleChangePhoneNumber}
              />
            </FormLayout>
            <FormLayout>
              <Text variant="bodyMd" as="p" fontWeight="semibold">
                Email
              </Text>
              <TextField value={item.email} onChange={handleChangeEmail} />
            </FormLayout>
            
          </FormLayout.Group> */}
            {/* <Text variant="bodyMd" as="p" fontWeight="semibold">
            Address
          </Text>
          <TextField value={item.address} onChange={handleChangeAddress} /> */}

            <TextField
              value={item.email}
              onChange={handleChangeEmail}
              label="Email"
            />
          </FormLayout>
        </Card>
        <PageActions
          primaryAction={{
            content: "Save",
            onClick: handleSave,
            loading: isSaving && true,
          }}
        />
        {toastMarkup}
      </Page>
    )
  );
};

export default ContactInformation;
